import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = () => {
  // ÄNDERUNG: Immer Light Mode erzwingen
  document.body.classList.remove('dark');
  document.documentElement.style.setProperty('color-scheme', 'light');

  // Optional: LocalStorage auf 'light' setzen, um konsistent zu bleiben
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, 'light');
};
